<div class="row d-flex justify-content-center pt-4 pb-4">
  <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 text-center">
    <img src="../../../assets/ChannelWorks-Logo.png" class="img-fluid mb-5" alt="Logo" />
  </div>
</div>
